import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';


function isHlsSource(src) {
  return Boolean(src) && /\.m3u8($|\?)/i.test(src);
}


export default function VideoPlayer({ src, className = '', autoPlay = false }) {
  const videoRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) {
      return undefined;
    }

    let hls;
    setError('');

    if (isHlsSource(src)) {
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
        video.load();
      } else if (Hls.isSupported()) {
        hls = new Hls({
          enableWorker: true,
        });
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.ERROR, (_, data) => {
          if (data?.fatal) {
            setError('Adaptive stream failed to load.');
          }
        });
      } else {
        setError('This browser does not support adaptive video playback.');
      }
    } else {
      video.src = src;
      video.load();
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
    };
  }, [src]);

  if (error) {
    return (
      <div className="mol-preview-modal__unsupported">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <video
      ref={videoRef}
      controls
      autoPlay={autoPlay}
      playsInline
      className={className}
    >
      Your browser does not support video playback.
    </video>
  );
}